import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'

import PageView from '@components/PageView'
import useRouteBuilder from '@hooks/useRouteBuilder'

import Broker from '@pages/Thankyou/Broker'
import Success from '@pages/Thankyou/Success'
import BrokerGymSearchMap from '@pages/BrokerGymSearchMap'
import ConfirmEmail from '@pages/ConfirmEmail'
import NotFound from '@pages/NotFound'

import {
  ClientAcquisitionFlow,
  BrokerAcquisitionFlow,
} from './pages/AcquisitionFlow'

export default function UkRoutes() {
  const { buildRoute } = useRouteBuilder()

  const pages = [
    {
      key: 'acquisition-flow',
      path: '/simulate',
      component: ClientAcquisitionFlow,
    },
    {
      key: 'acquisition-flow',
      path: '/simulate/:origin',
      component: ClientAcquisitionFlow,
    },
    {
      key: 'confirm-email',
      path: '/confirm-email',
      component: ConfirmEmail,
    },
    {
      key: 'broker-acquisition-flow',
      path: '/broker/simulate/:origin/',
      component: BrokerAcquisitionFlow,
    },
    {
      key: 'broker-map',
      path: '/broker/map',
      component: BrokerGymSearchMap,
    },
    {
      key: 'success',
      path: '/thank-you/success',
      component: Success,
    },
    {
      key: 'broker-thank-you',
      path: '/thank-you/broker',
      component: Broker,
    },
  ]

  return (
    <Switch>
      {pages.map(({ key, path, component }) => (
        <PageView
          exact
          key={key}
          path={buildRoute(path)}
          component={component}
        />
      ))}
      <Redirect to={buildRoute('/')} />
      <Route component={NotFound} />
    </Switch>
  )
}
